import { render, staticRenderFns } from "./TableColumnInvoiceStatus.vue?vue&type=template&id=ab4be1d0&"
import script from "./TableColumnInvoiceStatus.vue?vue&type=script&lang=js&"
export * from "./TableColumnInvoiceStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports